import { UPDATE_COUNTRY_LIST, UPDATE_STATES_LIST } from "../action/types";

const initialState = {
  countryList: [],
  stateList: [],
};

export default function surveyPartReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_COUNTRY_LIST:
      return {
        ...state,
        countryList: action.payload,
      };
    case UPDATE_STATES_LIST:
      const stateList = [...state.stateList].concat(action.payload);
      return {
        ...state,
        stateList: stateList,
      };
    default:
      return state;
  }
}
